import { createRoot } from "react-dom/client";
import { Buffer } from "buffer";
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./lib/service-worker-registration";
import { initSentry } from "./lib/sentry";

globalThis.Buffer ??= Buffer;

registerServiceWorker();

initSentry();

createRoot(document.getElementById("root")!).render(<App />);
